export default [
	{ value: 'uk', label: 'УКР' },
	{ value: 'en', label: 'ENG' },
];
